import { TimelineMax, Linear } from "gsap";
import App from '../../../vendor_core/core/src/App';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import ISpineWinSymbolViewConfig from '../../../vendor_core/core/src/managers/contracts/configurations/ISpineWinSymbolViewConfig';
import ISymbolSpineAnimConfig from '../../../vendor_core/core/src/managers/contracts/configurations/ISymbolSpineAnimConfig';
import { IOverlayData } from "../../../vendor_core/core/src/server/data/ISpinData";
import GameLoader from '../../../vendor_core/core/src/utils/GameLoader';
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import Layout from '../../../vendor_core/core/src/utils/Layout';
import PromiseHelpers from "../../../vendor_core/core/src/utils/PromiseHelpers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import SymbolSpineAnimation from '../../../vendor_core/core/src/views/SymbolSpineAnimation';
import WinSymbolsView from "../../../vendor_core/core/src/views/WinSymbolsView";
import BBModel from '../model/BBModel';
import BBAnimationsHelper from "../utils/BBAnimationsHelper";
import BBUtils from '../utils/utils';
import BBReelGroup from "./BBReelGroup";

export default class BBWinSymbolsView extends WinSymbolsView {
    public reelSymMapSpine: SymbolSpineAnimation[] = [];
    public winSymbolConfig: ISpineWinSymbolViewConfig = null;
    constructor() {
        super();
    }

    public create(
        scene: SceneView,
        extraSymbols: number,
        winSymbolsLayer?: string
    ) {
        super.create(scene, extraSymbols, winSymbolsLayer);
        this.winSymbolConfig = ConfigManager.getConfig(ConfigurationTypes.WIN_SYMBOL_SPINE_ANIMATIONS);
        this.createSpineAnimations(this.winSymbolConfig.preGenerateNumberOfSymbols);
    }
    public returnSpineToPool = (anim: SymbolSpineAnimation) => {
        this.reelSymMapSpine.push(anim);
    }

    public createSpineAnimations(animNumbers: number): void {
        if (animNumbers > 0) {
            let id = ConfigManager.getConfig(ConfigurationTypes.WIN_SYMBOL_SPINE_ANIMATIONS).defaultID | 0;
            for (let i = 0; i < animNumbers; i++) {
                let anim = this.createSpineAnim();
                anim.setActiveSkin(id);
                this.reelSymMapSpine.push(anim);
                if (this.winSymbolsContainer) {
                    this.winSymbolsContainer.addChild(anim);
                } else {
                    this.addChild(anim);
                }
            }
        }
    }
    public createSpineAnimation(): SymbolSpineAnimation {
        let id = ConfigManager.getConfig(ConfigurationTypes.WIN_SYMBOL_SPINE_ANIMATIONS).defaultID | 0;
        let anim = this.createSpineAnim();
        anim.setActiveSkin(id);
        this.reelSymMapSpine.push(anim);
        if (this.winSymbolsContainer) {
            this.winSymbolsContainer.addChild(anim);
        } else {
            this.addChild(anim);
        }

        return anim
    }

    protected createSpineAnim = (): SymbolSpineAnimation => {
        let config = (ConfigManager.getConfig((ConfigurationTypes.SYMBOL_SPINE_ANIMATIONS)) as ISymbolSpineAnimConfig);
        let anim = new SymbolSpineAnimation(
            GameLoader.loader.resources[`spine~${config.name}~json`].spineData,
            config.name,
            config
        );
        anim.scale.set(Layout.globalScale);
        anim.hide();

        return anim
    }
    protected getAnimFromPool(): SymbolSpineAnimation {
        let result: SymbolSpineAnimation;

        if (this.reelSymMapSpine.length > 0) {
            result = this.reelSymMapSpine.shift();
        } else {
            result = this.createSpineAnimation();
        }

        return result
    }

    protected setAnimPosition(anim: SymbolSpineAnimation, x: number, y: number) {
        anim.x = x;
        anim.y = y;
    }
    public moveSpineSymbolsToCenter(
        overlay: IOverlayData,
        positions?: { reel: number, row: number }[],
    ): Promise<boolean> {
        let counter = 0;
        let promisesList = [];
        const scene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as BBReelGroup;

        if (this.reelSymMapSpine && overlay && overlay.path && overlay.path.length > 0) {
            const wilds = BBUtils.searchWilds(overlay.symbolPosition);
            wilds.forEach(wild => {
                const anim = this.getAnimFromPool();
                let animPosition = this.getPositionAt(wild.x, wild.y);
                this.setAnimPosition(anim, animPosition.x, animPosition.y);
                anim.play();

                if (overlay.path) {

                    let result = overlay.path[counter];

                    let symToHide = reelGroup.getSymbolAt(wild.x, wild.y);
                    let promise = new Promise(res => {
                        let tl = new TimelineMax({
                            paused: true,
                            onComplete: () => {
                                anim.playChainingStates("star_land_chain")
                                App.dispatcher.once(
                                    GameEvents.ALL_REELS_STOPPED,
                                    () => {
                                        anim.hide();
                                        this.returnSpineToPool(anim)
                                    },
                                    this
                                )
                                res();
                            },
                        });

                        let duration = 0.5

                        let position = this.getPositionAt(
                            result.reel,
                            result.row
                        );

                        let firstPosition = this.getPositionAt(positions[counter].reel, positions[counter].row)

                        let centerTl = new TimelineMax({
                            // delay after spin animation start (client - Pol want that)
                            delay: 0.3,
                            paused: true,
                            onStart: () => {
                                anim.play("star_tornado_mode");
                            },
                            onComplete: () => {
                                anim.play("star_land");
                                tl.play()
                            }
                        })

                        symToHide.hide();
                        symToHide.spineAnim.hide();

                        centerTl.to(anim, duration, {
                            x: firstPosition.x,
                            y: anim.position.y > firstPosition.y ? (firstPosition.y + anim.height / 4) : (firstPosition.y - anim.height / 4),
                            ease: Linear.easeNone,
                        });
                        centerTl.add(() => BBAnimationsHelper.playWindAnimation(wild.y, (
                            anim.x > firstPosition.x ? "right" : "left"
                        )), 0);

                        tl.to(anim, duration, {
                            x: position.x,
                            y: position.y,
                            ease: Linear.easeNone,
                        });

                        centerTl.play()
                    })
                    promisesList.push(promise);
                    counter += 1;
                }
            })
        }
        return PromiseHelpers.combineParallel(promisesList);
    }
    public moveSpineSymbols(
        overlay: IOverlayData,
    ): Promise<boolean> {
        let counter = 0;
        let promisesList = [];
        const scene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as BBReelGroup;
        if (this.reelSymMapSpine && overlay && overlay.path && overlay.path.length > 0) {
            const wilds = BBUtils.searchWilds(overlay.symbolPosition);
            wilds.forEach(wild => {
                if (overlay.path) {
                    const anim = this.getAnimFromPool();

                    let animPosition = this.getPositionAt(
                        wild.x,
                        wild.y
                    );
                    this.setAnimPosition(anim, animPosition.x, animPosition.y)

                    anim.play("star_tornado_mode");

                    let result = overlay.path[counter];

                    let symToHide = reelGroup.getSymbolAt(wild.x, wild.y);
                    let next = reelGroup.getSymbolAt(result.reel, wild.y);


                    BBModel.setChangeWildFromReelData({
                        reel: wild.x,
                        row: wild.y
                    });

                    BBModel.setChangeWildToReelData({
                        reel: result.reel,
                        row: wild.y
                    })

                    let promise = new Promise(res => {
                        let tl = new TimelineMax({
                            paused: true,
                            onComplete: () => {

                                next.setId(0)
                                next.playSpineAnim("land_chain");
                                anim.hide();
                                this.returnSpineToPool(anim)

                                res();
                            },
                        });

                        let duration = 0.3

                        let position = this.getPositionAt(
                            result.reel,
                            result.row
                        );

                        if (anim.x !== position.x) {
                            symToHide.visible = false;

                            tl.to(anim, duration, {
                                x: position.x,
                                ease: Linear.easeNone,
                            });
                            tl.add(() => BBAnimationsHelper.playWindAnimation(wild.y, (
                                wild.x > result.reel ? "right" : "left"
                            )), 0);

                            tl.play();
                        } else {
                            res()
                        }

                    })
                    promisesList.push(promise);
                    counter += 1;
                }

            })
        }
        return PromiseHelpers.combineParallel(promisesList);
    }
}
